import { useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Button, styled, Typography } from '@mui/material'
import { Pagination } from '$comp/auth-slider/pagination'
import { goToAuthStartingPage } from '$logic/router'
import { t } from '$i18n'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const Root = styled('div')(({ theme }) => ({
  maxHeight: `100%`,
  height: `100%`,
  backgroundColor: theme.palette.secondary50,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
}))

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  width: 100%;
  margin-top: auto;
  box-sizing: border-box;
  gap: 32px;
`

const StyledButton = styled(Button)(({ theme }) => ({
  height: '48px',
  borderRadius: '8px',
  color: theme.palette.neutral000,
  backgroundColor: theme.palette.neutral1000,
  '&:hover': {
    backgroundColor: theme.palette.neutral1000,
  },
}))

const SLIDER_DATA = [
  {
    cover: 'login-1.png', // TODO: add to translation
    title: t('auth.sliders.first.title'),
    description: t('auth.sliders.first.description'),
  },
  {
    cover: 'login-2.png',
    title: t('auth.sliders.second.title'),
    description: t('auth.sliders.second.description'),
  },
  {
    cover: 'login-3.png',
    title: t('auth.sliders.third.title'),
    description: t('auth.sliders.third.description'),
  },
] as {
  cover: string
  title: string
  description: string
  mask: string
}[]

const CloseButton = styled(Button)`
  border-color: ${({ theme }) => theme.palette.neutral000};
  color: ${({ theme }) => theme.palette.neutral000};
  &:hover {
    border-color: ${({ theme }) => theme.palette.neutral000};
  }
  z-index: 2;
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 8px 16px;
  min-width: unset;
`

export function AuthSlider() {
  const swiperRef = useRef(null)
  const [pageIndex, setPageIndex] = useState(0)
  return (
    <Root>
      <CloseButton
        variant="outlined"
        size={AvatarSize.XS}
        onClick={goToAuthStartingPage}
      >
        {t('auth.sliders.pass')}
      </CloseButton>
      <Swiper
        style={{ width: '100%', height: '100%' }}
        ref={swiperRef}
        onSlideChange={e => setPageIndex(e.realIndex)}
      >
        {Array(3)
          .fill(null)
          .map((_, index) => (
            <SwiperSlide
              style={{
                height: '100%',
                width: '100%',
                minHeight: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
              key={index}
            >
              <img
                src={`assets/icons/${SLIDER_DATA[index].cover}`}
                style={{ width: '100%', minHeight: '300px' }}
                alt=""
              />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  alignItems: 'center',
                  padding: '24px 16px 0',
                }}
              >
                <Typography variant="h2">{SLIDER_DATA[index].title}</Typography>
                <Typography variant="paragraph1" textAlign="center">
                  {SLIDER_DATA[index].description}
                </Typography>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
      <ButtonContainer>
        <Pagination index={pageIndex} />
        <StyledButton
          variant="contained"
          fullWidth
          onClick={() => {
            if (pageIndex === 2) goToAuthStartingPage()
            else {
              setPageIndex(pageIndex + 1)
              swiperRef.current.swiper.slideNext()
            }
          }}
        >
          {pageIndex === 2 ? t('auth.sliders.enter') : t('auth.sliders.next')}
        </StyledButton>
      </ButtonContainer>
    </Root>
  )
}
